import { render, staticRenderFns } from "./ListQuiz.vue?vue&type=template&id=56fabc94&scoped=true&"
import script from "./ListQuiz.vue?vue&type=script&lang=js&"
export * from "./ListQuiz.vue?vue&type=script&lang=js&"
import style0 from "./ListQuiz.vue?vue&type=style&index=0&id=56fabc94&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fabc94",
  null
  
)

export default component.exports